import React from "react";

// Sample data structure representing the notifications in the image
const notificationsData = [
  {
    title: "Your Puja Slot is Confirmed",
    detail:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    time: "10 mins ago",
    image: "/images/service1.svg",
  },
  {
    title: "Your Puja Slot is Scheduled",
    detail:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    time: "10 mins ago",
    image: "/images/service2.svg",
  },
  {
    title: "New Message Received",
    detail:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    time: "10 mins ago",
    image: "/images/service3.svg",
  },
  {
    title: "New article launched",
    detail:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    time: "10 mins ago",
    image: "/images/service4.svg",
  },
  {
    title: "Your Puja Slot is Confirmed",
    detail:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    time: "10 mins ago",
    image: "/images/service1.svg",
  },
  {
    title: "New article launched",
    detail:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    time: "10 mins ago",
    image: "/images/service2.svg",
  },
];

// Helper component for a single notification item
const NotificationItem = ({ title, detail, time, image }) => (
  <div className="flex items-center p-[15px] lg:p-[20px] bg-white rounded-[20px] border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer">
    {/* Icon (Fixed width, yellow background) */}
    <div className="flex-shrink-0 w-[76px] h-[76px] p-[10px] bg-primary-100 rounded-full flex items-center justify-center mr-4">
      <img src={image} alt="" />
    </div>

    {/* Content (Takes remaining width) */}
    <div className="flex-grow min-w-0">
      <div className="flex justify-between items-start flex-wrap gap-[5px]">
        {/* Title and Detail */}
        <h3 className="web-h5 pr-2 mb-1">{title}</h3>

        {/* Time (Pushed to the far right, non-breaking space used) */}
        <span className="body-sm text-gray-500">{time}</span>
      </div>

      {/* Description */}
      <p className="body-md text-gray-600 mt-1 line-clamp-2">{detail}</p>
    </div>
  </div>
);

function Notifications() {
  return (
    <>
      <section className="notifications-bg py-8 md:py-12 bg-white">
        <div className="container">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <h1 className="web-h3 text-gray-950">Notifications</h1>
          </div>

          {/* Notifications List Container */}
          <div className="flex flex-col gap-[15px]">
            {notificationsData.map((notification, index) => (
              <NotificationItem
                key={index}
                title={notification.title}
                detail={notification.detail}
                time={notification.time}
                image={notification.image}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Notifications;
